<template>
  <div v-if="shareUrl" class="d-flex justify-center">
    <v-btn
      v-clipboard:copy="shareUrl"
      v-clipboard:success="onCopy"
      :block="false"
      color="primary"
      class="width: fit-content; text-uppercase"
      outlined
      x-small
      depressed
    >
      <v-icon v-if="!copyInProgress" x-small>{{ icons.mdiContentCopy }}</v-icon>
      &nbsp;
      {{ copyLabel }}
    </v-btn>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { mdiContentCopy } from '@mdi/js'

export default {
  name: 'CopyButton',
  data: () => ({
    icons: { mdiContentCopy },
    copyInProgress: false
  }),
  computed: {
    copyLabel() {
      return this.copyInProgress
        ? this.$t('action.panels.FUNDRAISER_THANKS.shareLink.shareLinkCopiedLabel', this.locale)
        : this.$t('action.panels.FUNDRAISER_THANKS.shareLink.shareLinkCopyLabel', this.locale)
    },
    shareUrl() {
      return this.formConfig.share_url
    },
    ...mapState('actionForm', ['locale', 'formConfig'])
  },
  methods: {
    onCopy() {
      this.copyInProgress = true
      setTimeout(() => {
        this.copyInProgress = false
      }, 1500)
    }
  }
}
</script>
